<app-external-header [showButtons]="false"></app-external-header>

<div class="pricing-page">
  <div class="pricing-container">
    <div class="pricing-header">
      <h1 class="pricing-title">{{ 'pricing.title' | translate }}</h1>
      <p class="pricing-subtitle">{{ 'pricing.subtitle' | translate }}</p>
    </div>

    <div class="spinner-wrapper" *ngIf="loading">
      <mat-spinner diameter="48"></mat-spinner>
    </div>

    <div class="steps-list" *ngIf="!loading">
      <div
        *ngFor="let step of journey.steps"
        class="step-card"
        [ngClass]="{
          'step-completed': step.status === StepStatus.COMPLETED,
          'step-recommended': step.recommended && step.status !== StepStatus.COMPLETED,
          'step-locked': step.status === StepStatus.LOCKED
        }"
      >
        <div class="step-left">
          <div class="step-label-row">
            <span class="step-label">{{ 'pricing.' + stepKey(step) + '.label' | translate }}</span>
            <span class="recommended-badge" *ngIf="step.recommended && step.status === StepStatus.AVAILABLE">
              <mat-icon class="badge-icon">check</mat-icon>
              {{ 'pricing.step2.recommended' | translate }}
            </span>
          </div>
          <h2 class="step-title">{{ 'pricing.' + stepKey(step) + '.title' | translate }}</h2>
          <p class="step-desc">{{ 'pricing.' + stepKey(step) + '.desc' | translate }}</p>
        </div>

        <div class="step-right">
          <ng-container *ngIf="step.status !== StepStatus.PENDING_VALIDATION && step.status !== StepStatus.IN_PROGRESS">
            <span
              class="step-price"
              [ngClass]="{ 'locked-price': step.status === StepStatus.LOCKED }"
            >
              {{ formatPrice(step) }}
            </span>
            <span class="step-note">{{ 'pricing.' + stepKey(step) + '.note' | translate }}</span>
            <span class="step-vat-note" *ngIf="showsVatNote(step)">TVA 19% incluse</span>
          </ng-container>

          <!-- COMPLETED -->
          <div class="status-badge completed" *ngIf="step.status === StepStatus.COMPLETED">
            <mat-icon class="badge-icon">check</mat-icon>
            {{ 'pricing.step1.status' | translate }}
          </div>

          <!-- PENDING VALIDATION (with booking date/time) -->
          <ng-container *ngIf="step.status === StepStatus.PENDING_VALIDATION">
            <div class="booking-info" *ngIf="step.bookingDate">
              <span class="booking-date">
                <mat-icon class="badge-icon">calendar_today</mat-icon>
                {{ formatBookingDate(step) }}
              </span>
              <span class="booking-time">
                <mat-icon class="badge-icon">schedule</mat-icon>
                {{ formatBookingTime(step) }}
              </span>
            </div>
            <div class="status-badge pending">
              <mat-icon class="badge-icon">event</mat-icon>
              {{ 'pricing.statusPendingValidation' | translate }}
            </div>
          </ng-container>

          <!-- IN PROGRESS -->
          <div class="status-badge in-progress" *ngIf="step.status === StepStatus.IN_PROGRESS">
            <mat-icon class="badge-icon">autorenew</mat-icon>
            {{ 'pricing.statusInProgress' | translate }}
          </div>

          <!-- AVAILABLE — show action only for consultation step -->
          <button
            class="book-btn"
            *ngIf="step.status === StepStatus.AVAILABLE && step.type === StepType.CONSULTATION"
            (click)="bookConsultation()"
          >
            <mat-icon class="book-icon">calendar_today</mat-icon>
            {{ 'pricing.step2.action' | translate }}
          </button>

          <!-- AVAILABLE — unlocked status for non-consultation steps -->
          <div class="unlock-badge" *ngIf="step.status === StepStatus.AVAILABLE && step.type !== StepType.CONSULTATION">
            <mat-icon class="unlock-icon">lock_open</mat-icon>
            {{ 'pricing.statusUnlocked' | translate }}
          </div>

          <!-- LOCKED -->
          <div class="lock-badge" *ngIf="step.status === StepStatus.LOCKED">
            <mat-icon class="lock-icon">lock</mat-icon>
            {{ 'pricing.' + stepKey(step) + '.unlock' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="pricing-footer" *ngIf="!loading">
      <button class="skip-btn" (click)="goToMain()">{{ 'pricing.skip' | translate }}</button>
    </div>
  </div>
</div>

<app-footer></app-footer>
